export const FLAG_NAMES = {
  DATADOG_RUM_ENABLED: "datadogRumEnabled",
  FLAG_TO_TEST_WITH: "flagtotestwith",
} as const;
